import { useIsMobile, useIsTablet, useMediaQuery } from "@/hooks/use-mobile";

interface CardTitleProps {
  title: string;
  subtitle?: string;
  className?: string;
}

const CardTitle = ({ title, subtitle, className = "" }: CardTitleProps) => {
  const isMobile = useIsMobile();
  const isTablet = useIsTablet();
  // Extra small is < 375px (not 480px) to differentiate from normal mobile (425px)
  const isExtraSmall = useMediaQuery("(max-width: 374px)");

  return (
    <div className={className}>
      <h3
        className={`${
          isExtraSmall
            ? "text-sm"
            : isMobile
            ? "text-base"
            : isTablet
            ? "text-xs"
            : "text-base"
        } font-semibold text-gray-900 dark:text-white`}
      >
        {title}
      </h3>
      {subtitle && (
        <p
          className={`${
            isExtraSmall
              ? "text-xs"
              : isMobile
              ? "text-sm"
              : isTablet
              ? "text-[9px]"
              : "text-xs"
          } text-gray-700 dark:text-white mt-0.5`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default CardTitle;
